import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { ComposeOperation } from 'owa-mail-compose-store';
import isRoamingSignatureEnabled from 'owa-roaming-signature-option/lib/utils/isRoamingSignatureEnabled';
import { getStore as getRoamingSignatureStore } from 'owa-mail-signature/lib/store/signatureStore';

export default function shouldAutoAddSignature(operation: ComposeOperation): boolean {
    const userOptions = getUserConfiguration().UserOptions;
    const {
        defaultSignatureName,
        defaultReplySignatureName,
        roamingSignatureMap,
    } = getRoamingSignatureStore();
    let autoAddSignature = false;
    switch (operation) {
        case ComposeOperation.New:
            if (isRoamingSignatureEnabled()) {
                autoAddSignature =
                    roamingSignatureMap.size > 0 && !!roamingSignatureMap.get(defaultSignatureName);
            } else {
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2322 (23,17): Type 'boolean | undefined' is not assignable to type 'boolean'.
                // @ts-expect-error
                autoAddSignature = userOptions.AutoAddSignature;
            }
            break;
        case ComposeOperation.Reply:
        case ComposeOperation.ReplyAll:
        case ComposeOperation.Forward:
            if (isRoamingSignatureEnabled()) {
                autoAddSignature =
                    roamingSignatureMap.size > 0 &&
                    !!roamingSignatureMap.get(defaultReplySignatureName);
            } else {
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2322 (37,17): Type 'boolean | undefined' is not assignable to type 'boolean'.
                // @ts-expect-error
                autoAddSignature = userOptions.AutoAddSignatureOnReply;
            }
            break;
    }

    return autoAddSignature;
}
